export function handleKeyDown(event: any) {
    return event.key === 'Enter' && event.preventDefault();
}